import React from "react"
import styled from "styled-components"
import { useIntl } from "gatsby-plugin-react-intl"
import { graphql, useStaticQuery } from "gatsby"

import { Container, Row, Col } from "../../components/Grid"
import Snippet from "../Snippet"
import NavigationIconGrid from "../NavigationIconGrid"

import { media, mixins } from "../../styles"
import Link from "../Link"

const Wrapper = styled.div`
  background: ${({ theme }) => theme.greyLight};
  padding: 50px 0;

  @media ${media.md} {
    padding: 60px 0 80px;
  }
`

const Header = styled.div`
  margin-bottom: 50px;
  text-align: center;

  h2 {
    ${mixins.title5}
  }
`

const LinkRow = styled.div`
  ${mixins.copy5}
  text-align: center;
  margin-top: 50px;

  a {
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    transition: color ${({ theme }) => theme.transitionTime};
    justify-content: center;

    .link-icon {
      margin-left: 5px;
    }

    &:hover {
      color: ${({ theme }) => theme.spaceblue};
    }
  }
`

const CrossNav = ({ current }) => {
  const { locale } = useIntl()

  const data = useStaticQuery(graphql`
    query IndustriesCrossNavQuery {
      allIndustries: allContentfulIndustry(
        filter: {
          hasIndustryPage: { eq: true }
          hideIndustryPageFromNavigation: { ne: true }
        }
        sort: { name: ASC }
      ) {
        nodes {
          id
          name
          node_locale
          slug
          icon: iconSmall {
            ...ContentfulImageData
          }
        }
      }
    }
  `)

  const industries = data.allIndustries.nodes
    .filter((node) => node.node_locale === locale)
    .filter((node) => node.slug !== current)

  return industries.length > 1 ? (
    <Wrapper>
      <Container>
        <Row>
          <Col>
            <Header>
              <h2>
                <Snippet id="industriesCrossnav" field="header" />
              </h2>
            </Header>
          </Col>
        </Row>
        <Row>
          <Col md="10" mdOffset="1" lg="12" lgOffset="0" xl="8" xlOffset="2">
            <NavigationIconGrid
              basePath="/industries/"
              iconColor="sun"
              items={industries}
              mode="crossnav"
            />
          </Col>
        </Row>
        <LinkRow>
          <Link
            arrow
            intl={false}
            to={Snippet({ id: "industriesCrossnav", field: "linkUrl" })}
          >
            {Snippet({ id: "industriesCrossnav", field: "linkText" })}
          </Link>
        </LinkRow>
      </Container>
    </Wrapper>
  ) : (
    <></>
  )
}

export default CrossNav
